module.exports = __webpack_public_path__ + "img/angle_90.5693bda9.jpg";